module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/166-morocco-a5cd1bbdc6d57b0b80bf322f6bb9adbb.svg";